export interface InvestmentOpportunity {
  id: string;
  title: string;
  description: string;
  category: string;
  status: InvestmentStatus;
  location: string;
  rating: number;
  image: string;
  investmentAmount: number;
  expectedReturn: number;
  duration: number; // in months
  riskLevel: RiskLevel;
  sectors: string[];
  contactPerson: string;
  contactEmail: string;
  contactPhone: string;
  establishedDate: Date;
  lastUpdated: Date;
  isActive: boolean;
}

export enum InvestmentStatus {
  AVAILABLE = 1,
  ACTIVE = 2,
  COMPLETED = 3,
  SUSPENDED = 4
}

export enum RiskLevel {
  LOW = 'low',
  MEDIUM = 'medium',
  HIGH = 'high'
}

export interface InvestmentOpportunityFormData {
  title: string;
  description: string;
  category: string;
  status: InvestmentStatus;
  location: string;
  rating: number;
  image: File | string | null;
  investmentAmount: number;
  expectedReturn: number;
  duration: number;
  riskLevel: RiskLevel;
  sectors: string[];
  contactPerson: string;
  contactEmail: string;
  contactPhone: string;
  isActive: boolean;
}

export interface InvestmentOpportunityFilters {
  search?: string;
  category?: string;
  status?: InvestmentStatus;
  riskLevel?: RiskLevel;
  minInvestment?: number;
  maxInvestment?: number;
  location?: string;
}

export const INVESTMENT_CATEGORIES = [
  'Industri Manufaktur',
  'Teknologi',
  'Pariwisata',
  'Pertanian',
  'Perdagangan',
  'Jasa',
  'Infrastruktur',
  'Energi',
  'Real Estate',
  'Lainnya'
];

export const INVESTMENT_SECTORS = [
  'Gitar Baki',
  'Tekstil',
  'Furniture',
  'Otomotif',
  'Agroindustri',
  'Kuliner',
  'Kerajinan',
  'Digital',
  'Logistik',
  'Kesehatan'
];

export const STATUS_LABELS: Record<InvestmentStatus, string> = {
  [InvestmentStatus.AVAILABLE]: 'Tersedia',
  [InvestmentStatus.ACTIVE]: 'Aktif',
  [InvestmentStatus.COMPLETED]: 'Selesai',
  [InvestmentStatus.SUSPENDED]: 'Ditangguhkan'
};

export const RISK_LEVEL_LABELS: Record<RiskLevel, string> = {
  [RiskLevel.LOW]: 'Rendah',
  [RiskLevel.MEDIUM]: 'Sedang',
  [RiskLevel.HIGH]: 'Tinggi'
};